import yup from 'utils/yup';

export const initialSegmentedTrackingData = {
  drivingSpeedThreshold: 10,
  idleIntervalThresholdInMinutes: 4,
  attribute_mileage_duration_to_job: false,
  attribute_to: null as any,
};

export const segmentedTrackingSettingsValidation = yup.object().shape({
  drivingSpeedThreshold: yup.string().required(),
  idleIntervalThresholdInMinutes: yup.string().required(),
  attribute_mileage_duration_to_job: yup.boolean().required(),
  attribute_to: yup
    .string()
    .nullable()
    .when('attribute_mileage_duration_to_job', {
      is: true,
      then: schema => schema.required('This field is required when mileage duration is attributed to a job.'),
      otherwise: schema => schema.notRequired(),
    }),
});
